import React from 'react';
import { Dropdown as BootstrapDropdown } from 'react-bootstrap';
import styled from 'styled-components';
import { colors } from '../../../theme/colors';

const getSurfaceBg = (props) => (props.theme && props.theme.colors && props.theme.colors.surface && props.theme.colors.surface.background) || '#f0f0f0';
const getFontFamily = (props) => (props.theme && props.theme.typography && props.theme.typography.fontFamily && props.theme.typography.fontFamily.base) || 'sans-serif';
const getFontSizeSm = (props) => (props.theme && props.theme.typography && props.theme.typography.fontSize && props.theme.typography.fontSize.sm) || '14px';
const getBrandPrimary = (props) => (props.theme && props.theme.colors && props.theme.colors.brand && props.theme.colors.brand.primary) || colors.brandDarkBlue;
const getBrandSecondary = (props) => (props.theme && props.theme.colors && props.theme.colors.brand && props.theme.colors.brand.secondary) || colors.brandLightBlue;

export const StyledDropdown = styled(BootstrapDropdown)`
  display: inline-block;
`;

export const CustomToggle = React.forwardRef(({ children, onClick, ...props }, ref) => (
  <button
    ref={ref}
    onClick={(e) => {
      e.preventDefault();
      onClick(e);
    }}
    {...props}
    style={{
      background: 'none',
      border: 'none',
      color: colors.brandDarkBlue,
      cursor: 'pointer',
      fontSize: '1.2rem',
      padding: '4px 8px',
      borderRadius: '4px',
      transition: 'background-color 0.2s',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      outline: 'none',
    }}
    onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = 'rgba(0, 169, 255, 0.05)')}
    onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = 'transparent')}
    onFocus={(e) => (e.currentTarget.style.backgroundColor = 'rgba(0, 169, 255, 0.05)')}
    onBlur={(e) => (e.currentTarget.style.backgroundColor = 'transparent')}
  >
    {children || <i className="fas fa-ellipsis-v" />}
  </button>
));

export const StyledMenu = styled(BootstrapDropdown.Menu)`
  background-color: #ffffff;
  border-radius: 8px;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.15);
  border: 1px solid ${props => getSurfaceBg(props)};
  padding: 8px 0;
  min-width: 180px;
  width: max-content;
  z-index: 9999 !important;
`;

export const StyledItem = styled(BootstrapDropdown.Item)`
  font-family: ${props => getFontFamily(props)};
  font-size: ${props => getFontSizeSm(props)};
  color: ${props => getBrandPrimary(props)};
  padding: 10px 20px;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
  white-space: nowrap;

  &:hover {
    background-color: ${props => getSurfaceBg(props)};
    color: ${props => getBrandSecondary(props)};
  }

  i {
    width: 16px;
    text-align: center;
    color: inherit;
    opacity: 0.8;
  }

  span {
    flex: 1;
    overflow: hidden;
    text-overflow: ellipsis;
    text-align: left;
  }
`;

export const StyledDivider = styled(BootstrapDropdown.Divider)`
  margin: 8px 0;
  border-top: 1px solid ${props => getSurfaceBg(props)};
`;



// WEBPACK FOOTER //
// ./src/design-system/atoms/Dropdown/components/DropdownStyles.js